import React from 'react';
import { useTranslation } from 'react-i18next';
import './Landing.css';
import { HeroSection, ROIDisplay } from './landing/LandingHeader';
import VisualSideContent from './landing/VisualSideContent';
import RegistrationForm from './landing/RegistrationForm';
import FeaturesSection from './landing/FeaturesSection';
import LanguageSwitcher from './LanguageSwitcher';

const Landing = () => {
  const { t } = useTranslation();

  return (
    <div className="landing-page">
      <LanguageSwitcher />
      {/* <CabinetButton /> */}
      <div className="asymmetric-container">
        <div className="visual-section">
          <div className="visual-content">
            <HeroSection />
            <ROIDisplay />
            <VisualSideContent />
          </div>
          <div className="visual-decoration"></div>
        </div>
        <div className="content-section">
          <div className="content-wrapper">
            <RegistrationForm />
            <FeaturesSection />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;

